var chunkMapping = {
	"36": [
		8063
	],
	"229": [
		3329,
		190,
		8315,
		8910,
		290,
		9795,
		2845
	],
	"521": [
		9521
	],
	"595": [
		8595
	],
	"886": [
		886
	]
};
var idToExternalAndNameMapping = {
	"190": [
		"default",
		"./useLegacyAllContractsAndRolesCardMembership",
		2819
	],
	"290": [
		"default",
		"./stores",
		7734
	],
	"886": [
		"default",
		"./HeaderHomeNotification",
		4648
	],
	"2845": [
		"default",
		"./useLegacyCurrentAccountContracts",
		2819
	],
	"3329": [
		"default",
		"./useHubRoutes",
		619
	],
	"8063": [
		"default",
		"./TelevetProductSection",
		1589
	],
	"8315": [
		"default",
		"./useLegacyHubRoutes",
		2819
	],
	"8595": [
		"default",
		"./VPISection",
		2819
	],
	"8910": [
		"default",
		"./useMostViewedTelevetRoutes",
		1589
	],
	"9521": [
		"default",
		"./PrivacyAndTermsCheck",
		8521
	],
	"9795": [
		"default",
		"./components/sections",
		7734
	]
};
var idToRemoteMap = {
	"190": [
		{
			"externalType": "script",
			"name": "contractLegacy",
			"externalModuleId": 2819
		}
	],
	"290": [
		{
			"externalType": "script",
			"name": "medical",
			"externalModuleId": 7734
		}
	],
	"886": [
		{
			"externalType": "script",
			"name": "notification",
			"externalModuleId": 4648
		}
	],
	"2845": [
		{
			"externalType": "script",
			"name": "contractLegacy",
			"externalModuleId": 2819
		}
	],
	"3329": [
		{
			"externalType": "script",
			"name": "clubePublication",
			"externalModuleId": 619
		}
	],
	"8063": [
		{
			"externalType": "script",
			"name": "televet",
			"externalModuleId": 1589
		}
	],
	"8315": [
		{
			"externalType": "script",
			"name": "contractLegacy",
			"externalModuleId": 2819
		}
	],
	"8595": [
		{
			"externalType": "script",
			"name": "contractLegacy",
			"externalModuleId": 2819
		}
	],
	"8910": [
		{
			"externalType": "script",
			"name": "televet",
			"externalModuleId": 1589
		}
	],
	"9521": [
		{
			"externalType": "script",
			"name": "term",
			"externalModuleId": 8521
		}
	],
	"9795": [
		{
			"externalType": "script",
			"name": "medical",
			"externalModuleId": 7734
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}